import jwt_decode from 'jwt-decode';
import { isLocalOrStubs } from '../environment/environment';
import { logAPIErrorToNewrelic } from '../wishList/utils';

export const NO_TOKEN = '';

export const auth0 = (): JLAuth0Client => window.__auth0__ || window.auth0;

export const authenticate = async (): Promise<string> => {
    let token = NO_TOKEN;

    try {
        if (isLocalOrStubs()) {
            return NO_TOKEN; // this allows us to access the site locally and in stubs
        }

        // https://gitlab.com/JohnLewisPartnership/digital/services/customer-identity/shared-auth/-/blob/master/src/auth/auth.js#L95
        const authResult = await auth0().getTokenIfAuthenticated();

        if (authResult) {
            token = authResult;
            window.listingAuth0Claims = jwt_decode(token);
        } else {
            logAPIErrorToNewrelic('authenticate', 'Auth Failed with empty token');
        }
    } catch (e) {
        // silently swallow
        logAPIErrorToNewrelic('authenticate', 'Auth Failed with an Exception', { exception: e });
    }

    return token;
};
